module.exports = __webpack_public_path__ + "static/img/charts.70af04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/charts.png
// module id = KHiZ
// module chunks = 1